import { render } from "./basicAuth.vue?vue&type=template&id=f5e5d4fe&scoped=true"
import script from "./basicAuth.vue?vue&type=script&lang=js"
export * from "./basicAuth.vue?vue&type=script&lang=js"

import "./basicAuth.vue?vue&type=style&index=0&id=f5e5d4fe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e5d4fe"]])

export default __exports__